import { Burger } from '../core'

$.fn.Header = function(parent) {
  let self = this
  self.cloned = undefined
  self.parent = parent
  self.burger = undefined
  self.scrolling = $('.app').ScrollEvents()
  self.past = false

  if (self.data('header')) {
    return self.data('header')
  }

  self.initialize_burger = function() {
    self.burger = new Burger(self.find('.header__burger').get(0), {
      onToggle: function(burger) {
        $('body').removeClass('--classeur-open')
        if (burger.isExpanded) {
          $('body').addClass('--menu-open --no-scroll')
          if (self.parent != undefined) {
            self.parent.burger.maybe_open()
          } else if (self.cloned != undefined) {
            self.cloned.burger.maybe_open()
          }
        } else {
          $('body').removeClass('--menu-open --no-scroll')
          if (self.parent != undefined) {
            self.parent.burger.maybe_close()
          } else if (self.cloned != undefined) {
            self.cloned.burger.maybe_close()
          }
        }
      },
    })
  }

  self.scrolled = function(top, direction) {
    if (!self.past && top > 300) {
      $('.app').addClass('--header-visible')
      self.past = true
    } else if (self.past && top <= 300) {
      $('.app').removeClass('--header-visible')
      self.past = false
    }
  }

  self.initialize_cloned = function() {
    self.cloned = self.clone().Header(self)
    self.after(self.cloned)
  }

  self.shrink_menu = function() {
    let biggest_item = 0;
    let ratio = 1;
    $('.menu-wrapper .main-menu__link').each(function(){
      if ($(this).width() + 50 > biggest_item) {
        biggest_item = $(this).width() + 50;
      }
    })
    var new_ratio = $('.main-menu').width() / biggest_item;
    if (new_ratio < 1) {
      ratio = new_ratio;
    } else {
      ratio = 1;
    }
    $('.main-menu').css('--scale', ratio);
  }

  return function() {
    $(window).on('load resize orientationchange', self.shrink_menu)
    if (self.parent == undefined) {
      setTimeout(function() {
        $('body').removeClass('--menu-dismissed--initial')
      }, 250)
    }
    self.initialize_burger()
    if (self.parent != undefined) {
      self.addClass('header--fixed')
    }
    if (self.parent == undefined) {
      self.initialize_cloned()
      self.scrolling.add(self.scrolled)
      $(window).on('load resize orientationchange', self.scrolled)
      self.scrolled()
      self.data('header', self)
    }
    return self
  }()
}
